import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/@headlessui+react@2.2.4_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.3.6_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.6_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/components/elements/button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/diamond-polishing.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/final-product.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/igi_certificate.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/machine.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/memorial.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/new_born_couple.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/proposal.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/get-to-know/upgrade_ring.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/hero/hero-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/hero/work_on_phone.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/home/carbon_graphite.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/home/diamonds.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/home/hair_strands.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/home/raw_diamond.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/kit/left-side.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/blue-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/halo-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/radiant-ring.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/shared/public/images/learn-more/why-bonded/ring-box.jpg");
